<template>
  <div>
    <pd-common-styles></pd-common-styles>
    <v-navigation-drawer
      :color="'#1b2e43'"
      v-model="drawer"
      :permanent="permanent"
      :mini-variant="miniVariant"
      app
      dark
    >
      <v-list-item>
        <v-list-item-content>
          <v-img
            :src="`${urlBundles.baseUrl}assets/passdelivery_white.svg`"
            :height="24"
            position="left center"
            contain
            v-if="!miniVariant"
          ></v-img>
          <v-img
            :src="`${urlBundles.baseUrl}assets/passdelivery-red-point.svg`"
            :height="24"
            contain
            v-if="miniVariant"
          ></v-img>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list nav dense shaped style="padding: 8px !important;">
          <v-list-item-group v-model="group">
              <v-list-item @click="gotoUrl(urlBundles.adminHome)">
                  <v-list-item-icon>
                      <v-icon>mdi-storefront-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                      {{
              $t("pages.admin.stores.title")
                      }}
                  </v-list-item-title>
              </v-list-item>
              <v-list-item @click="gotoUrl(urlBundles.adminUsers)">
                  <v-list-item-icon>
                      <v-icon>mdi-account-multiple</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                      {{
              $t("pages.admin.users.title")
                      }}
                  </v-list-item-title>
              </v-list-item>
              <v-list-item @click="gotoUrl(urlBundles.adminReport)">
                  <v-list-item-icon>
                      <v-icon>mdi-file-chart</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                      {{
              $t("pages.admin.report.title")
                      }}
                  </v-list-item-title>
              </v-list-item>
              <v-list-item @click="gotoUrl(urlBundles.passepartoutCommunications)">
                  <v-list-item-icon>
                      <v-icon>mdi-message-text</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                      {{
                            $t("pages.admin.communications.title")
                      }}
                  </v-list-item-title>
              </v-list-item>

          </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar dense outlined elevate-on-scroll app :color="$vuetify.theme.dark ? '': 'white'">
        <v-app-bar-nav-icon @click="setMiniVariant"></v-app-bar-nav-icon>

        <v-spacer></v-spacer>

        <v-checkbox v-model="darkMode"
                    color="yellow"
                    off-icon="mdi-theme-light-dark"
                    on-icon="mdi-theme-light-dark"
                    @click="toggleDarkMode"
                    class="theme-button">
        </v-checkbox>

        <v-toolbar-title class="account-info">
            <div class="account-name">{{ userInfo.name }}</div>
            <div class="account-role">
                {{ $t("roles." + Math.abs(userInfo.currentRoleId)).toUpperCase() }}
            </div>
        </v-toolbar-title>
        <v-avatar color="indigo" size="32" style="margin-right: 10px">
            <span class="white--text">{{ initials }}</span>
        </v-avatar>       

        <v-menu :rounded="false">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="user-options-btn">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list dense flat :elevation="1">
                <v-list-item @click="logout()">
                    <v-list-item-title>Esci</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
    <snackbar-hub></snackbar-hub>
  </div>
</template>

<script>
    import { UrlBundles, UserInfo, EventHub } from "Libs/core";
    import PdCommonStyles from "Components/pd-common-styles";
    import SnackbarHub from "Components/snackbar-hub";
    import _ from "lodash";
    import axios from "axios";
    import moment from "moment";

    export default {
        data() {
            return {
                axios: axios,
                moment: moment,
                miniVariant: this.$vuetify.breakpoint.mobile ? false : true, //this.$vuetify.breakpoint.mobile,
                drawer: this.$vuetify.breakpoint.mobile ? false : true,
                permanent: this.$vuetify.breakpoint.mobile ? false : true,
                urlBundles: UrlBundles,
                userInfo: UserInfo,
                eventHub: EventHub,
                snackbar: false,
                serverErrorSnackbar: false,
                darkMode: false

            };
        },
        computed: {
            initials() {
                let initials = this.userInfo.name.match(/\b\w/g) || [];
                return ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
            },
            switchLabel: function () {
                return this.darkMode ? 'light' : 'dark';
            }
        },
        methods: {
            gotoUrl(url) {
                window.location.href = url;
            },
            logout() {
                localStorage.clear();
                window.location.href = this.urlBundles.logout;
            },
            setMiniVariant() {
                !this.$vuetify.breakpoint.mobile &&
                    (this.miniVariant = !this.miniVariant);
                this.$vuetify.breakpoint.mobile && (this.drawer = !this.drawer);
                localStorage.setItem("miniVariant", this.miniVariant);
            },
            toggleDarkMode() {
                this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
                this.darkMode = this.$vuetify.theme.dark;
                localStorage.setItem("darkTheme", this.$vuetify.theme.dark.toString());

                this.changeScrollBarTheme();
            },
            changeScrollBarTheme() {
                var darkStyle = "::-webkit-scrollbar-track {background: #121212;}    ::-webkit-scrollbar-thumb {background: #3e3e3e;border: solid 3px #121212;border-radius: 7px;}    ::-webkit-scrollbar-thumb:hover {background: white;}";

                var lightStyle = "::-webkit-scrollbar-track {background: #f0f0f0;}    ::-webkit-scrollbar-thumb {background: #7b7b7b;border: solid 3px #f0f0f0;border-radius: 7px;}    ::-webkit-scrollbar-thumb:hover {background: #272727;}";

                if (this.$vuetify.theme.dark)
                    document.getElementById("styleScrollbar").innerHTML = darkStyle;
                else
                    document.getElementById("styleScrollbar").innerHTML = lightStyle;
            }
        },
        mounted() {
            this.$nextTick(() => {
                if (!this.$vuetify.breakpoint.mobile) {
                    if (localStorage.getItem("miniVariant") !== null) {
                        this.miniVariant = eval(localStorage.getItem("miniVariant"));
                    } else {
                        localStorage.setItem("miniVariant", true);
                        this.miniVariant = true;
                    }
                }

                const themeDark = localStorage.getItem("darkTheme");

                if (themeDark) {

                    if (themeDark === "true") {
                        this.$vuetify.theme.dark = true;
                    } else {
                        this.$vuetify.theme.dark = false;
                    }

                } else if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
                    this.$vuetify.theme.dark = true;
                    localStorage.setItem("darkTheme", this.$vuetify.theme.dark.toString());
                }

                this.darkMode = this.$vuetify.theme.dark;

                this.changeScrollBarTheme();
            });
        },
        props: {
            color: {
                type: String,
                default: "#fff",
            },
        },
        components: {
            PdCommonStyles,
            SnackbarHub,
        },
    };
</script>

<style lang="scss">
    .store-logo {
        height: 36px;
        margin-right: 20px;
    }

    .store-description {
        font-size: 18px;
    }

    .warning-bar {
        height: 48px;
        line-height: 48px;
        margin-top: 48px;
        text-align: center;
        background: #ff98009e;
        width: 100%;
        color: #fff;
    }

    .user-options-btn {
        height: 32px !important;
        width: 32px !important;
    }

    .account-info {
        text-align: right;
        margin-right: 20px;

        .account-name {
            font-size: 0.8rem;
            font-weight: bold;
        }

        .account-role {
            font-size: 0.6rem;
        }
    }

    .v-application--is-ltr .v-list.v-sheet--shaped {
        padding-left: 0;
    }

    .v-list--nav .v-list-item {
        border-radius: 0;
    }

    .theme-button {
        height: 24px !important;        
        margin-right: 15px;
    }
</style>
